
























    
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import { ClientProject, ClientProjectService, ClientProjectTask, ClientProjectTaskService, ClientProjectTaskWork } from '../../../../services/accounting.service';
import { HashMap } from '../../../../services/base.service';

@Component({})
export default class LogHoursForm extends Vue {

    @Prop()
    public project!: ClientProject;

    @Prop()
    public task!: ClientProjectTask;

    api!: ClientProjectTaskService;

    request: ClientProjectTaskWork = {
        notes: '',
        hours: 0,
    }

    loading = false;
    errors: HashMap<string> = {};

    created() {
        this.api = new ClientProjectTaskService(this.project.id);
    }

    async submit() {
        this.loading = true;
        const res = await this.api.workOn(this.task, this.request);
        if (res.success === true) {
            this.request = {
                notes: '',
                hours: 0,
            }
            this.$emit('success', res.result);
        } else {
            this.errors = res.error;
        }
        this.loading = false;
    }

}

